module.exports = __webpack_public_path__ + "static/media/rail.eadd61c4.svg";